import * as React from 'react';
const IconArrowLeft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={20}
    viewBox="0 0 24 20"
    fill="none"
    style={{ width: '24px', height: '20px' }}
    {...props}
  >
    <path
      d="M12.1318 0.919922C11.1126 -0.234953 9.38522 -0.312747 8.27344 0.746094L0.885742 7.78223C0.271835 8.3669 -0.0239944 9.17585 0.00390625 9.97754C-0.036993 10.7939 0.260363 11.6221 0.885742 12.2178L8.27344 19.2539C9.38528 20.3128 11.1126 20.2351 12.1318 19.0801C13.1511 17.9249 13.0758 16.1302 11.9639 15.0713L9.69727 12.9121H21.2686C22.7769 12.9121 23.9999 11.6423 24 10.0752C24 8.50806 22.7769 7.23828 21.2686 7.23828H9.53906L11.9639 4.92871C13.0758 3.86976 13.1511 2.07514 12.1318 0.919922Z"
      fill="#020000"
    />
  </svg>
);
export default IconArrowLeft;
